import React, { Component } from "react";
import { withAuthorization } from "../../Session";
import { withFirebase } from "../../Firebase";
import { withRouter } from "react-router-dom";
import { compose } from "recompose";
import NavigationMenus from "../../NavigationMenus";
import OverlayAlertBox from "../OverlayAlertBox";
import ModalAlert from "../ModalAlert";
import {
  Breadcrumbs,
  Chip,
  Typography,
  Link,
  Grid,
  Paper,
  Button,
  ButtonBase,
  LinearProgress,
  makeStyles,
  withStyles,
  StepConnector,
  Stepper,
  Step,
  StepLabel,
  TextField,
  Divider,
  Dialog,
  DialogContent,
  Box,
  Hidden,
  Snackbar,
  Checkbox,
  FormControlLabel,
  IconButton,
  Tooltip,
  Switch,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";
import * as ROUTES from "../../../constants/route";
import { AttachFileOutlined } from "@material-ui/icons";
import { AuthUserContext } from "../../Session";
import axios from "axios";
import * as uuid from "uuid";
import { withCookies } from "react-cookie";
import Helpers from "../../Helpers";
import { orange } from "@material-ui/core/colors";
import clsx from "clsx";
import { DropzoneAreaBase } from "material-ui-dropzone";
import {
  INVESTMENT_DROPZONE_ACCEPTED_TYPES,
  isUsableInvestmentUpload,
  materializeUploadFile,
  UPLOAD_READ_ERROR_MESSAGE,
} from "../../../utils/uploadFiles";
import WarningRoundedIcon from "@material-ui/icons/WarningRounded";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import NumberFormat from "react-number-format";
import CloseIcon from '@material-ui/icons/Close';

import PaymentImgWeb from "../../../images/payment-popup-web.png";
import PaymentImgMob from "../../../images/payment-popup-mobile.png";

import paymentOptionsData from "./payment_options";

import BPI from "../../../assets/paymentOptions/bpi-logo.png";
import UBQR from "../../../assets/QRCodes/UBQR.png";
import { Alert } from "@material-ui/lab";
import CopyUserId from "./Copyhelper";

import GetAppIcon from '@material-ui/icons/GetApp';
import {
  ELIGIBILITY_LOADING, getApplicableInvestmentMinimum, getFundEligibilityMessage, getInvestmentEligibilityMessage,
  getVisibleEligibilityMessage,
} from "../investmentEligibility";
import { getBookingRejectionMessage } from "../../../services/bookingLimits";

const MULTIPART_UPLOAD_ERROR = "Invalid multipart request";
const UPLOAD_RETRY_MESSAGE =
  "We couldn't upload your proof of payment. Please select the file again and retry.";
const UPLOAD_SIZE_MESSAGE =
  "Your proof of payment is too large to upload. Please select a file up to 9.5 MB.";

// V1 can report operational failures with HTTP 200, including after commit.
// Only producer-defined business/input rejections settle the attempt as rejected.
const BOOKING_INPUT_REJECTION_CODES = new Set([
  "invalid-tier", "invalid-amount", "max-amount-exceeded", "ongoing-transaction", "missing-rate",
  "missing-uuid", "missing-fund-code", "missing-fund", "invalid-req", "missing-req", "missing-picture",
  "idempotency-conflict", "user-not-found", "kyc-not-found", "fund-not-found", "kyc-refresh-required",
  "unauthorized", "user-mismatch", "no-file", "no-accepted-file", "invalid-multipart", "field-too-large",
  "unexpected-file-field", "duplicate-file-field", "too-many-files", "wrong-file-type",
  "invalid-file-signature", "invalid-heif-signature", "invalid-upload-metadata", "invalid-heif-dimensions",
]);

const isKnownBookingRejection = (body, status) => !!getBookingRejectionMessage(body) ||
  BOOKING_INPUT_REJECTION_CODES.has(body?.code) ||
  (body?.code == null && (body?.message === MULTIPART_UPLOAD_ERROR || [401, 403, 413].includes(status)));

const getInvestmentUploadErrorMessage = (error) => {
  const status = error?.response?.status;
  const responseData = error?.response?.data;
  const responseMessage =
    typeof responseData?.message === "string"
      ? responseData.message
      : typeof responseData === "string"
        ? responseData
        : "";
  const message = responseMessage || error?.message || "";

  if (status === 413) return UPLOAD_SIZE_MESSAGE;
  if (message === MULTIPART_UPLOAD_ERROR) return UPLOAD_RETRY_MESSAGE;
  if (status === 400 && !responseMessage) return UPLOAD_RETRY_MESSAGE;
  return message || UPLOAD_RETRY_MESSAGE;
};

const InvestmentConnector = withStyles({
  alternativeLabel: {
    top: 10,
    left: "calc(-50% + 16px)",
    right: "calc(50% + 16px)",
  },
  active: {
    "& $line": {
      borderColor: "#C8932A",
    },
  },
  completed: {
    "& $line": {
      borderColor: "#C8932A",
    },
  },
  line: {
    borderColor: "#eaeaf0",
    borderTopWidth: 3,
    borderRadius: 1,
  },
})(StepConnector);

const useStyles = makeStyles((theme) => ({
  button: {
    color: theme.palette.getContrastText(orange[900]),
    backgroundColor: "#C8932A",
    fontFamily: "Poppins",
    fontSize: "13px",
    padding: "10px 45px",
    "&:hover": {
      backgroundColor: "#b8892e",
    },
  },
  breakdownText: {
    fontSize: "medium",
  },
  breakdownTextBold: {
    fontWeight: "bold",
  },
  dropzoneStyle: {
    minHeight: "0px",
  },
  dropzoneIcon: {
    display: "none",
  },
  highlightedArea: {
    backgroundColor: "#C8932A",
    color: theme.palette.getContrastText(orange[900]),
  },
  paymentClickable: {
    padding: "5px",
    width: "100%",
    borderRadius: "5px",
    "&:hover": {
      backgroundColor: "#EBBC5F",
      cursor: "pointer",
    },
  },
  iconSize: {
    height: "auto",
    width: "100px",
  },
  iconSizeSmall: {
    height: "auto",
    width: "50px",
    marginRight: "10px",
  },
  qrClass: {
    marginLeft: "auto",
    marginRight: "auto",
    width: "100%",
    height: "auto",
  },
  debit: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginTop: "10px",
    transition: "background-color 0.3s",
    "&:hover": {
      backgroundColor: "#EBBC5F",
      cursor: "pointer",
      color: "white",
    },
  },
  modalContent: {
    position: 'relative',
    backgroundColor: '#246040',
    padding: theme.spacing(2),
    color: '#ffffff',
  },
  closeButton: {
    position: 'absolute',
    top: theme.spacing(1),
    right: theme.spacing(1),
    color: '#ffffff',
  },
  wavyContainer: {
    position: 'relative',
    backgroundColor: '#fff',
    borderRadius: '10px',
    overflow: 'hidden',
    '&::before': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundImage: 'url("/path-to-your-wavy-border.svg")', // Add wavy background image
      backgroundSize: 'cover',
      zIndex: -1,
    },
  },
  textContainer: {
    padding: theme.spacing(4),
    backgroundColor: '#2D6A4F', // Dark green for text area
    borderTopLeftRadius: '10px',
    borderTopRightRadius: '10px',
  },
  imageContainer: {
    backgroundImage: 'url("/path-to-your-image.jpg")', // Image for the modal
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    height: '200px',
  },
}));

const CustomTextField = withStyles({
  root: {
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#C8932A",
      },
      "&:hover fieldset": {
        borderColor: "#ebab2d",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#b88c35",
      },
    },
  },
})(TextField);

const PaymentPage = () => {
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <>
      <NavigationMenus
        disableFab={true}
        content={
          <Payment
            classes={classes}
            isMobile={isMobile}
          />
        }
      />
    </>
  );
};

export class PaymentBase extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      success: false,
      processingTimeline: "",
      processingTimelineInfo: "",
      amount: "",
      fee: 10.0,
      picture: null,
      slip: [],
      pictureSecondary: null,
      slipSecondary: [],
      materializingPrimary: false,
      materializingSecondary: false,
      hasLongKYC: null,
      modalOpen: true,
      uuid: null,
      validated: null,
      docId: null,
      hasPending: false,
      investStep: 0,
      minAmount: 1000,
      fund: null,
      eligibilityError: "",
      uncertainAttempt: null,
      hasSelectedPayment: false,
      currentSelectedPayment: null,
      paymentChoices: paymentOptionsData,
      errorModal: false,
      additionalUpload: false,
      tooltipAccountTip: false,
      tooltipAccountNameTip: false,
      userAccNum: "",
      tier: null,
      initialDialogOpen: true,
    };
    this.helpers = new Helpers();
    this.uploadGeneration = { primary: 0, secondary: 0 };
  }

  static contextType = AuthUserContext;

  componentDidMount() {
    this.loadPaymentData();
    window.history.pushState(null, null, window.location.href);
    window.addEventListener("popstate", this.handlePopState);
    window.addEventListener("beforeunload", this.handleBeforeUnload);
    this.setState({ uuid: uuid.v4() });
  }

  loadPaymentData = async () => {
    if (this.unmounted) return;
    const generation = (this.paymentGeneration || 0) + 1;
    this.paymentGeneration = generation;
    this.setState({ docId: null, fund: null, hasPending: false, eligibilityError: "" });
    var uid = this.context.uid;
    this.paymentUid = uid;
    var userRef = this.props.firebase.db.collection("users");
    var fundid = this.props.match.params.fundid; //params.fundid is the fund name
    var fundRef = this.props.firebase.db.collection("funds");
    let transRef = this.props.firebase.db.collection("transactions");
    let investmentsRef = this.props.firebase.db.collection("investments");
    let accountId;

    try {
      const [userDoc, kycDoc, funds, pending] = await Promise.all([
        userRef.doc(uid).get(),
        userRef.doc(uid).collection("KYC").doc("KYC").get(),
        fundRef.where("name", "==", fundid).get(),
        transRef.where("clientDetails.userUid", "==", uid).where("status", "==", "processing").get(),
      ]);
      accountId = userDoc.data()?.accountNumber;
      if (!funds.docs[0]) {
        if (generation === this.paymentGeneration && !this.unmounted) this.props.history.replace("/404");
        return;
      }
      if (typeof accountId !== "string" || !accountId.trim()) throw new Error("Account unavailable");
      const fund = { ...funds.docs[0].data(), id: funds.docs[0].id };
      const holdings = await investmentsRef.where("useruid", "==", accountId).get();
      if (generation !== this.paymentGeneration || this.unmounted || uid !== this.context.uid || fundid !== this.props.match.params.fundid) return;
      const kyc = kycDoc.data();
      const minAmount = getApplicableInvestmentMinimum(fund, holdings.docs.map((doc) => doc.data()));
      if (!Number.isFinite(minAmount) || minAmount <= 0) throw new Error("Fund minimum unavailable");
      this.setState({
        docId: funds.docs[0].id, fund, minAmount,
        hasPending: pending.docs.some((doc) => doc.data().fundDetails?.fundName === fundid),
        userAccNum: accountId || "", tier: userDoc.data()?.stats?.tier,
        validated: kyc ? !["pending", "declined"].includes(kyc.validated) : null,
        hasLongKYC: !kyc ? false : ["pending", "declined"].includes(kyc.validated) ? null : !!userDoc.data()?.hasLongKYC,
        processingTimeline: fund.processingTimeline?.trim() || "",
        processingTimelineInfo: fund.processingTimelineInfo?.trim() || "",
      });
    } catch {
      if (generation === this.paymentGeneration) this.setState({ eligibilityError: "Unable to load fund eligibility. Please retry before investing." });
    }
  };

  componentWillUnmount() {
    this.unmounted = true;
    this.activeSubmission = null;
    this.submitting = false;
    this.paymentGeneration = (this.paymentGeneration || 0) + 1;
    this.uploadGeneration.primary += 1;
    this.uploadGeneration.secondary += 1;
    window.removeEventListener("popstate", this.handlePopState);
    window.removeEventListener("beforeunload", this.handleBeforeUnload);
  }

  handleBeforeUnload = (event) => {
    if (this.state.amount != 0) {
      const confirmationMessage =
        "You have unsaved changes. Are you sure you want to leave?";
      event.preventDefault();
      event.returnValue = confirmationMessage;
    }
  };

  handlePopState = () => {
    if (this.state.amount != 0) {
      const confirmationMessage =
        "You have unsaved changes. Are you sure you want to go back?";
      if (!window.confirm(confirmationMessage)) {
        window.history.pushState(null, null, window.location.href);
      } else {
        window.removeEventListener("popstate", this.handlePopState);
        window.history.back();
      }
    }
  };

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.match.params.fundid !== this.props.match.params.fundid || this.paymentUid !== this.context.uid) {
      this.activeSubmission = null;
      this.submitting = false;
      this.uploadGeneration.primary += 1;
      this.uploadGeneration.secondary += 1;
      this.setState({ uuid: uuid.v4(), amount: "", picture: null, slip: [], pictureSecondary: null, slipSecondary: [],
        loading: false, success: false, uncertainAttempt: null, materializingPrimary: false, materializingSecondary: false,
        investStep: 0, hasSelectedPayment: false, currentSelectedPayment: null, additionalUpload: false,
        paymentChoices: { ...this.state.paymentChoices,
          payment_options: this.state.paymentChoices.payment_options.map((option) => ({ ...option, selected: false })) },
        validated: null, hasLongKYC: null, processingTimeline: "", processingTimelineInfo: "", modalOpen: true });
      this.loadPaymentData();
      return;
    }
    if (
      this.state.amount !== prevState.amount &&
      this.state.amount >= this.state.minAmount &&
      this.state.amount <= this.props.fundEligibility?.data?.remainingAmount &&
      !this.getEligibilityMessage()
    ) {
      const queryParams = new URLSearchParams(this.props.location.search);
      const currentStep = queryParams.get('step');

      if (!currentStep || currentStep === '1') {
        queryParams.set('step', 2);
        this.props.history.push({
          pathname: this.props.location.pathname,
          search: queryParams.toString(),
        });
      }
    }

    if (this.state.currentSelectedPayment !== prevState.currentSelectedPayment) {

      const queryParams = new URLSearchParams(this.props.location.search);
      const currentStep = queryParams.get('step');

      if (currentStep === '2') {
        queryParams.set('step', 3);
        this.props.history.push({
          pathname: this.props.location.pathname,
          search: queryParams.toString(),
        });
      }
    }
  }

  deletePicture = (secondary) => {
    if (!secondary) {
      this.uploadGeneration.primary += 1;
      return this.setState(
        {
          picture: null,
          slip: [],
          materializingPrimary: false,
        },
        () => {
          this.setInvestStep();
        }
      );
    }

    this.uploadGeneration.secondary += 1;
    return this.setState({
      pictureSecondary: null,
      slipSecondary: [],
      materializingSecondary: false,
    });
  };

  modal = () => {
    this.setState({
      modalOpen: !this.state.modalOpen,
      hasLongKYC: null,
    });
    // var fundid = this.props.match.params.fundid;
    var fundid = this.state.docId;
    this.props.history.push(ROUTES.FUNDS + "/" + fundid + "");
  };

  isAmountBlocked = () => {
    return this.props.fundEligibility?.status === "ready" && this.state.docId !== null &&
      this.props.fundEligibility.data.remainingAmount < this.state.minAmount;
  };

  matchesAttemptPayload = (attempt) => !!attempt && attempt.uid === this.context.uid &&
    attempt.fundId === this.state.docId && attempt.fundName === this.props.match.params.fundid &&
    attempt.uuid === this.state.uuid && attempt.amount === this.state.amount && attempt.picture === this.state.picture &&
    attempt.pictureSecondary === (this.state.additionalUpload ? this.state.pictureSecondary : null);

  isUncertainRetry = () => !this.unmounted && this.matchesAttemptPayload(this.state.uncertainAttempt);

  isCurrentSubmission = (attempt) => !this.unmounted && this.activeSubmission === attempt &&
    attempt.generation === this.paymentGeneration && attempt.uid === this.context.uid &&
    attempt.fundName === this.props.match.params.fundid && attempt.fundId === this.state.docId;

  getEligibilityMessage = (fundEligibility = this.props.fundEligibility, retry = this.isUncertainRetry()) =>
    this.state.eligibilityError || (retry && fundEligibility?.status === "ready"
      ? getFundEligibilityMessage(this.state.fund, fundEligibility.data.tier, fundEligibility.kyc)
      : getInvestmentEligibilityMessage(this.state.fund, fundEligibility, this.state.minAmount)) ||
    (!this.state.docId ? ELIGIBILITY_LOADING : !this.state.fund?.status ? "This fund is unavailable for investment." :
      this.state.hasPending && !retry ? "We are currently processing one of your transactions for this fund." : "");

  handleChange = (event) => {
    if (event.target.value > 0)
      this.setState({ [event.target.name]: event.target.value }, () => {
        this.setInvestStep();
      });
  };

  setInvestStep = () => {
    let step = 0;
    if (this.state.amount !== "") step = 1;

    if (this.state.picture !== null) step = 2;
    else step = 1;

    this.setState({ investStep: step });
  };

  submit = (e) => {
    e.preventDefault();
    this.checkAmount(e);
  };

  checkAmount = (e) => {
    e.preventDefault();

    return this.submitInvestment();
  };

  submitInvestment = async () => {
    if (this.unmounted || this.submitting || this.state.success) return;
    const initialMessage = this.getEligibilityMessage();
    if (initialMessage) {
      this.setState({ loading: false });
      const visibleMessage = getVisibleEligibilityMessage(initialMessage);
      if (visibleMessage) alert(visibleMessage);
      return;
    }
    this.submitting = true;
    const attempt = Object.freeze({ uid: this.context.uid, fundId: this.state.docId, fundName: this.props.match.params.fundid,
      generation: this.paymentGeneration, uuid: this.state.uuid, amount: this.state.amount, picture: this.state.picture,
      pictureSecondary: this.state.additionalUpload ? this.state.pictureSecondary : null });
    this.activeSubmission = attempt;
    this.setState({ loading: true });
    let sent = false;
    try {
      const fundEligibility = await this.props.fundEligibility.refresh();
      if (!this.isCurrentSubmission(attempt) || !this.matchesAttemptPayload(attempt)) return;
      const retry = this.isUncertainRetry();
      const eligibilityMessage = fundEligibility ? this.getEligibilityMessage(fundEligibility, retry) :
        "We couldn't confirm your investment allowance. Please retry before investing.";
      const amount = Number(attempt.amount);
      if (eligibilityMessage || !Number.isFinite(amount) || amount <= 0 || amount < this.state.minAmount ||
          (!retry && amount > fundEligibility?.data?.remainingAmount) ||
          Math.abs(amount * 100 - Math.round(amount * 100)) > 0.000001) {
        alert(getVisibleEligibilityMessage(eligibilityMessage) || "Enter a valid amount within the fund minimum and your remaining investment allowance (up to two decimal places).");
        return;
      }
      if (this.state.materializingPrimary || this.state.materializingSecondary) return;
      const invalidPrimary = !isUsableInvestmentUpload(attempt.picture);
      const invalidSecondary = attempt.pictureSecondary !== null && !isUsableInvestmentUpload(attempt.pictureSecondary);
      if (invalidPrimary || invalidSecondary) {
        this.setState({ ...(invalidPrimary ? { picture: null, slip: [] } : {}),
          ...(invalidSecondary ? { pictureSecondary: null, slipSecondary: [] } : {}) }, this.setInvestStep);
        alert("The selected proof of payment is no longer available. Please select it again.");
        return;
      }
      const formData = new FormData();
      formData.append("req", JSON.stringify({ uuid: attempt.uuid, userUid: attempt.uid,
        fundId: attempt.fundId, fundName: attempt.fundName, amount: attempt.amount }));
      formData.append("picture", attempt.picture);
      if (attempt.pictureSecondary !== null) formData.append("pictureSecondary", attempt.pictureSecondary);
      sent = true;
      const res = await axios.post(
        `${ROUTES.FUNCTION_BASE_URL}investments-investments/createNewInvestment`,
        formData,
        { headers: { Authorization: `Bearer ${this.props.cookies.get("token")}` } }
      );
      if (!this.isCurrentSubmission(attempt)) return;
      if (res.data?.ok !== true) {
        throw Object.assign(new Error(res.data?.message || "Unable to confirm investment submission"), { response: res });
      }
      this.setState({ uncertainAttempt: null, success: true });
      this.props.fundEligibility.refresh();
    } catch (err) {
      if (!this.isCurrentSubmission(attempt)) return;
      const businessMessage = getBookingRejectionMessage(err?.response?.data);
      const uncertain = sent && !isKnownBookingRejection(err?.response?.data, err?.response?.status);
      // A failed read/auth check cannot settle the outcome of an earlier uncertain POST.
      if (sent && !(this.isUncertainRetry() && [401, 403].includes(err?.response?.status))) {
        this.setState({ uncertainAttempt: uncertain ? attempt : null });
      }
      this.helpers.handleError(err);
      if (![401, 403].includes(err?.response?.status)) {
        alert(uncertain
          ? "We couldn't confirm whether your investment was received. Retry without changing the amount or proof of payment to check the same request."
          : businessMessage || (sent ? getInvestmentUploadErrorMessage(err) : "Please retry the investment allowance check before investing."));
      }
      if (uncertain || businessMessage) this.props.fundEligibility.refresh();
    } finally {
      if (this.isCurrentSubmission(attempt)) {
        this.activeSubmission = null;
        this.submitting = false;
        this.setState({ loading: false });
      }
    }
  };

  getSteps = () => {
    return [
      "Enter amount to be invested",
      "Transfer payment",
      "Submit proof of payment",
    ];
  };

  handleDropzone = async (files) => {
    const selected = files[0];
    if (!selected) return;

    const generation = ++this.uploadGeneration.primary;
    this.setState({ materializingPrimary: true });
    try {
      const file = await materializeUploadFile(selected.file, selected.data);
      if (generation !== this.uploadGeneration.primary) return;
      this.setState(
        {
          picture: file,
          slip: [{ ...selected, file }],
          materializingPrimary: false,
        },
        this.setInvestStep
      );
    } catch {
      if (generation !== this.uploadGeneration.primary) return;
      this.setState({ materializingPrimary: false }, this.setInvestStep);
      alert(UPLOAD_READ_ERROR_MESSAGE);
    }
  };

  handleDropzoneSecondary = async (files) => {
    const selected = files[0];
    if (!selected) return;

    const generation = ++this.uploadGeneration.secondary;
    this.setState({
      materializingSecondary: true,
    });
    try {
      const file = await materializeUploadFile(selected.file, selected.data);
      if (generation !== this.uploadGeneration.secondary) return;
      this.setState({
        pictureSecondary: file,
        slipSecondary: [{ ...selected, file }],
        materializingSecondary: false,
      });
    } catch {
      if (generation !== this.uploadGeneration.secondary) return;
      this.setState({
        materializingSecondary: false,
      });
      alert(UPLOAD_READ_ERROR_MESSAGE);
    }
  };

  selectPaymentOption = (e, index) => {
    e.preventDefault(e);
    let options = this.state.paymentChoices.payment_options;
    options.forEach((value) => {
      value.selected = false;
    });
    options[index].selected = true;

    this.setState({
      paymentChoices: { ...this.state.paymentChoices, options },
      hasSelectedPayment: true,
      currentSelectedPayment: options[index],
    });
  };

  NumberFormatCustom(props) {
    const { inputRef, onChange, ...other } = props;

    return (
      <NumberFormat
        {...other}
        getInputRef={inputRef}
        onValueChange={(values) => {
          onChange({
            target: {
              name: props.name,
              value: values.value,
            },
          });
        }}
        thousandSeparator
        isNumericString
        prefix="₱ "
      />
    );
  }

  getSelectedPaymentDescription = () => {
    const { classes } = this.props;
    return (
      <>
        <h3>{this.state.currentSelectedPayment.name}</h3>
        <Divider />
        <br />
        <Grid container spacing={1}>
          <Grid item xs={12} sm={12} md={this.state.currentSelectedPayment.qrcode ? 10 : 12} lg={this.state.currentSelectedPayment.qrcode ? 10 : 12} xl={this.state.currentSelectedPayment.qrcode ? 10 : 12}>
            <p
              className="mt-4"
              dangerouslySetInnerHTML={{
                __html: this.state.currentSelectedPayment.details.description,
              }}
            />
            <p
              className="mx-5 text-sm"
              dangerouslySetInnerHTML={{
                __html: this.state.currentSelectedPayment.note,
              }}
            />
            <ul style={{ listStyleType: "none" }}>
              {this.state.currentSelectedPayment.details.steps.map((step) => (
                <li key={step.order}>
                  <div style={{ display: "flex", alignItems: "flex-start" }}>
                    <Typography
                      variant="body1"
                      color="primary"
                      style={{ minWidth: "3.5rem", fontWeight: "bold" }}
                    >
                      Step{" "}
                      {this.state.currentSelectedPayment.details.steps.indexOf(
                        step
                      ) + 1}
                      :
                    </Typography>
                    <div style={{ maxWidth: "80ch" }}>
                      <Typography
                        variant="body1"
                        dangerouslySetInnerHTML={{ __html: step.instruction }}
                      />
                    </div>
                  </div>
                  {step.instruction.includes("Bank Details") ? (
                    <ul style={{ listStyleType: "none", paddingLeft: "4em" }}>
                      {this.state.currentSelectedPayment.name === "GCash Bank Transfer"
                        &&
                        <li style={{ marginBottom: "-15px" }} >
                          <b>Account Name:</b> RAMPVER FINANCIALS INC
                          <CopyUserId acctNum="RAMPVER FINANCIALS INC" />
                        </li>}
                      <li>
                        <b>Account Number:</b> 002130009962{" "}
                        {this.state.currentSelectedPayment.details.description.includes(
                          "Unionbank App!"
                        ) && <CopyUserId acctNum="002130009962" />}
                        {this.state.currentSelectedPayment.name.includes(
                          "Bank via InstaPay"
                        ) && <CopyUserId acctNum="002130009962" />}
                        {this.state.currentSelectedPayment.name.includes(
                          "GCash Bank Transfer"
                        ) && <CopyUserId acctNum="002130009962" />}
                        {this.state.currentSelectedPayment.name.includes(
                          "Any Bank or E-Wallet via InstaPay"
                        ) && <CopyUserId acctNum="002130009962" />}
                        {this.state.currentSelectedPayment.name.includes(
                          "Any Bank via PESONet"
                        ) && <CopyUserId acctNum="002130009962" />}
                        {this.state.currentSelectedPayment.name.includes(
                          "Unionbank Over-The-counter (OTC)"
                        ) && <CopyUserId acctNum="002130009962" />}
                      </li>
                      {this.state.currentSelectedPayment.name !== "GCash Bank Transfer"
                        &&
                        <li style={{ marginTop: "-15px" }}>
                          <b>Account Name:</b> RAMPVER FINANCIALS INC
                          <CopyUserId acctNum="RAMPVER FINANCIALS INC" />
                        </li>}
                    </ul>
                  ) : (
                    step.instruction.includes(
                      "enter the numeric digits of your Rampver Online account number (RFXXXXXXXXXX) and click <b>Continue</b>"
                    ) && (
                      <div
                        style={{ listStyleType: "none", paddingLeft: "4em" }}
                      >
                        <CopyUserId
                          acctNum={this.state.userAccNum.slice(2, 100)}
                        />

                        <br />
                        <i>
                          Note: If your account number is RF<b>1234567890</b>,
                          your reference number is 1234567890 (total of 10
                          digits)
                        </i>
                        <br />
                        <br />
                      </div>
                    )
                  )}
                </li>
              ))}
              {this.state.currentSelectedPayment.sampleimg && (
                <>
                  <br />
                  <span className="ml-0 lg:ml-16 font-semibold text-lg">
                    Example:
                  </span>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      marginTop: "20px",

                    }}
                  >
                    <img
                      className="w-3/4 mr-8 lg:w-2/4 "
                      src={this.state.currentSelectedPayment.sampleimg}
                      alt="rampver-logo"
                    />
                  </div>
                </>
              )}
            </ul>
          </Grid>
          {this.state.currentSelectedPayment.qrcode && (
            <Grid item xs={12} sm={12} md={2} lg={2} xl={2}>

              <div style={{ marginRight: "auto", marginLeft: "auto" }}>
                <img className={classes.qrClass} src={this.state.currentSelectedPayment.name === 'Any Bank via PESONet' ? this.state.currentSelectedPayment.qrCustom : UBQR} alt="UBQRcode" />
              </div>
              <Button
                variant="outlined"
                color="primary"
                size="small"
                fullWidth
                onClick={this.handleDownload}
              >
                Download QR
              </Button>
            </Grid>
          )}
        </Grid>
      </>
    );
  };

  redirectAutoDebit = () => {
    const { fundid } = this.props.match.params;
    const { amount } = this.state;

    // Push both the URL and state
    this.props.history.push({
      pathname: `${ROUTES.RECURRING_INVESTMENT_INFO}`,
      search: `?fund=${fundid}&amount=${amount}`,
      state: {
        fromPayment: true,
        fundValue: fundid,
        investedValue: amount,
        minInitialValue: this.state.minAmount,
      },
    });
  };

  errorClose = () => {
    this.setState({ errorModal: false });
  };

  toggleSecondaryUpload = () => {
    if (this.state.additionalUpload) this.uploadGeneration.secondary += 1;
    this.setState((state) =>
      state.additionalUpload
        ? {
            additionalUpload: false,
            pictureSecondary: null,
            slipSecondary: [],
            materializingSecondary: false,
          }
        : { additionalUpload: true }
    );
  };

  handleDownload = () => {
    const imageSrc = this.state.currentSelectedPayment.name === 'Unionbank App'
      ? this.state.currentSelectedPayment.qrCustom
      : UBQR;

    const link = document.createElement('a');
    link.href = imageSrc;
    link.download = 'rampver-code.png';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  render() {
    const { classes, isMobile } = this.props;
    document.body.style.backgroundColor = "white";
    let modal;
    const {
      success,
      amount,
      picture,
      loading,
      hasLongKYC,
      modalOpen,
      validated,
      docId,
      hasPending,
      investStep,
      slip,
      processingTimeline,
      processingTimelineInfo,
      minAmount,
      paymentChoices,
      hasSelectedPayment,
      currentSelectedPayment,
      errorModal,
      additionalUpload,
      pictureSecondary,
      tier,
      initialDialogOpen,
      materializingPrimary,
      materializingSecondary,
    } = this.state;
    const maxRemaining = this.props.fundEligibility?.data?.remainingAmount ?? 0;
    const eligibilityMessage = this.getEligibilityMessage();
    const formatter = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "PHP",
      minimumFractionDigits: 2,
    });
    const isAmountBlocked = this.isAmountBlocked();

    if (tier === 1 && validated !== null && !validated) {
      modal = (
        <ModalAlert
          function={this.modal}
          open={modalOpen}
          message="Your application is still pending / was declined."
          validated={false}
          route={ROUTES.DASHBOARD}
        />
      );
    }     
    if (hasLongKYC !== null && !hasLongKYC) {
      modal = (
        <ModalAlert
          function={this.modal}
          open={modalOpen}
          validate={true}
          message="You have not yet completed your Client Application, Would you like to complete it now?"
          route={ROUTES.LONG_KYC}
        />
      );
    }
    if (hasPending !== null && hasPending && !this.isUncertainRetry()) {
      modal = (
        <ModalAlert
          function={this.modal}
          open={modalOpen}
          message="We are currently processing one of your transactions for this fund."
          validated={false}
          route={ROUTES.INVESTMENT_HISTORY}
        />
      );
    }
    const alertItem = (
      <Snackbar
        open={errorModal}
        onClose={this.errorClose}
        autoHideDuration={4000}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert severity="error">
          Upload a PNG, JPG/JPEG, AVIF, HEIC/HEIF, or PDF file up to 9.5 MB.
        </Alert>
      </Snackbar>
    );
    const paymentOptions = (
      <>
        <h3>Payment Options</h3>
        <Grid container spacing={1}>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <span>Choose one of the following:</span>
            <br />
          </Grid>
          {paymentChoices.payment_options.map((object, index) => (
            <>
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <Paper elevation={3} style={{ height: "100%" }}>
                  <ButtonBase
                    focusRipple
                    key={`payment-${index}`}
                    style={{ width: "100%", height: "100%" }}
                    onClick={(e) => this.selectPaymentOption(e, index)}
                    className={clsx(
                      classes.paymentClickable,
                      object.selected && classes.highlightedArea
                    )}
                  >
                    <Hidden smDown>
                      <div
                        style={{
                          width: "100%",
                          display: "flex",
                          alignItems: "center",
                          flexDirection: "column",
                        }}
                      >
                        <img
                          className={classes.iconSize}
                          src={object.img}
                          alt="payment-icon"
                        />
                        <br />
                        <br />
                        <span
                          style={{
                            fontFamily: "Gill Sans, Poppins",
                            fontSize: "14px",
                          }}
                        >
                          {object.name}
                        </span>
                      </div>
                    </Hidden>
                    <Hidden mdUp>
                      <div
                        style={{
                          width: "100%",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <img
                          className={classes.iconSizeSmall}
                          src={object.img}
                          alt="payment-icon"
                        />
                        <span
                          style={{
                            fontFamily: "Gill Sans, Poppins",
                            fontSize: "14px",
                          }}
                        >
                          {object.name}
                        </span>
                        {object.selected ? (
                          <ExpandMoreIcon
                            style={{
                              marginLeft: "auto",
                            }}
                          />
                        ) : (
                          <ChevronRightIcon
                            style={{
                              marginLeft: "auto",
                            }}
                          />
                        )}
                      </div>
                    </Hidden>
                  </ButtonBase>
                </Paper>
              </Grid>
              <Hidden mdUp>
                {hasSelectedPayment &&
                  object.selected === currentSelectedPayment.selected ? (
                  <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <Box
                      style={{
                        width: "100%",
                        height: "100%",
                        padding: "10px",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          width: "100%",
                          height: "100%",
                          padding: "5px",
                        }}
                      >
                        {this.getSelectedPaymentDescription()}
                      </div>
                    </Box>
                  </Grid>
                ) : (
                  ""
                )}
              </Hidden>
            </>
          ))}
          <Hidden smDown>
            {hasSelectedPayment ? (
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Box
                  style={{
                    width: "100%",
                    height: "100%",
                    padding: "10px",
                  }}
                >
                  <h4>
                    {currentSelectedPayment === null
                      ? ""
                      : currentSelectedPayment.label}
                  </h4>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      width: "100%",
                      height: "100%",
                      padding: "5px",
                    }}
                  >
                    {this.getSelectedPaymentDescription()}
                  </div>
                </Box>
              </Grid>
            ) : (
              ""
            )}
          </Hidden>
        </Grid>
      </>
    );

    let investDisable = true;
    // if (tier === 3 && picture !== null && amount >= minAmount )investDisable = false;
    // if (tier === 2 && picture !== null && amount <= maxRemaining && amount >= minAmount)
    if (
      !eligibilityMessage && !loading && picture !== null &&
      !materializingPrimary &&
      !materializingSecondary &&
      (amount <= maxRemaining || this.isUncertainRetry()) &&
      amount >= minAmount
    )
      investDisable = false;

    const initialDialogWeb = (
      <Dialog
        open={initialDialogOpen}
        onClose={() => this.setState({
          initialDialogOpen: false,
        })}
        maxWidth="md"
        PaperProps={{
          style: {
            backgroundColor: '#246040',
            borderRadius: '40px',
          }
        }}
      >
        <DialogContent style={{ padding: 0, backgroundColor: '#246040', }}>
          <Box
            display="flex"
            flexDirection="column"
            alignItems="flex-start"
            style={{
              backgroundColor: '#246040',
              padding: '20px 40px',
              color: 'white',
              position: 'relative'
            }}
          >
            <Typography variant="body1" style={{ fontWeight: 600 }}>
              Friendly Reminder
            </Typography>
            <Typography variant="h4" style={{ margin: '15px 0', fontWeight: 700, width: '70%' }}>
              Don’t forget to upload your proof of transfer!
            </Typography>
          </Box>
          <Box style={{
            position: 'relative',
            marginTop: '-220px',
            padding: 0
          }}>
            <div style={{ position: 'relative' }}>
              <img
                src={PaymentImgWeb}
                alt="Payment Image"
                style={{
                  width: '100%',
                  marginBottom: '-5px'
                }}
              />
              <IconButton
                style={{
                  position: 'absolute',
                  top: '55px',
                  right: '8px',
                  cursor: 'pointer',
                  color: 'white',
                }}
                onClick={() => this.setState({
                  initialDialogOpen: false,
                })}
              >
                <CloseIcon />
              </IconButton>
            </div>
          </Box>
        </DialogContent>
      </Dialog>
    )

    const initialDialogMobile = (
      <Dialog
        open={initialDialogOpen}
        onClose={() => this.setState({
          initialDialogOpen: false,
        })}
        maxWidth="xs"
        fullWidth={true}
        PaperProps={{
          style: {
            backgroundColor: '#246040',
            borderRadius: '40px',
          }
        }}
      >
        <DialogContent style={{ padding: 0, backgroundColor: '#246040', }}>
          <Box
            display="flex"
            flexDirection="column"
            alignItems="flex-start"
            style={{
              backgroundColor: '#246040',
              padding: '20px',
              color: 'white',
              position: 'relative'
            }}
          >
            <Typography variant="body1" style={{ fontWeight: 600 }}>
              Friendly Reminder
            </Typography>
            <Typography
              variant="h6"
              style={{
                margin: '15px 0',
                fontWeight: 700,
                width: '80%',
              }}
            >
              Don’t forget to upload your proof of transfer!
            </Typography>
          </Box>
          <Box
            style={{
              position: 'relative',
              marginTop: '-150px',
              padding: 0,
            }}
          >
            <img
              src={PaymentImgMob}
              alt="Payment Image"
              style={{
                width: '100%',
                marginBottom: '-5px',
              }}
            />
            <IconButton
              style={{
                position: 'absolute',
                top: '5px',
                right: '8px',
                cursor: 'pointer',
                color: 'white',
              }}
              onClick={() => this.setState({
                initialDialogOpen: false,
              })}
            >
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogContent>
      </Dialog>
    )
const noLimit = ( <div>
                <Grid
                  container
                  spacing={1}
                  justifyContent="flex-start"
                  alignItems="center"
                >
                  <Grid item xs={12} sm={12} md={12} lg={2} xl={2} />
                  <Grid item xs={12} sm={12} md={12} lg={8} xl={8}>
                    <Paper elevation={3} style={{ padding: "10px" }}>
                      <Grid container spacing={1}>
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                          <h3>Transfer Payment</h3>
                        </Grid>
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                          <>
                            <span>
                              You can pay for your Rampver Online investment
                              through your Unionbank App, GCash, BPI, or any
                              bank that allows Instapay or PESONet transactions!
                            </span>
                            <br />
                            <br />
                          </>
                          <Paper
                            elevation={3}
                            className={classes.highlightedArea}
                            style={{ padding: "10px" }}
                          >
                            <Grid container spacing={1}>
                              <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
                                <span
                                  className={clsx(
                                    classes.breakdownText,
                                    classes.breakdownTextBold
                                  )}
                                >
                                  Total Amount to be Paid:
                                </span>
                              </Grid>
                              <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
                                <span
                                  className={clsx(
                                    classes.breakdownText,
                                    classes.breakdownTextBold
                                  )}
                                  style={{ float: "right" }}
                                >
                                  {formatter.format(amount)}
                                </span>
                              </Grid>
                            </Grid>
                          </Paper>
                        </Grid>
                      </Grid>
                      {paymentOptions}
                      <br />
                      {/* {autoDebitBar} */}
                    </Paper>
                  </Grid>
                  <Grid item xs={12} sm={12} md={12} lg={2} xl={2} />
                </Grid>
              </div>)  ;
    return (
      <>
        {modal}
        {alertItem}
        {success ? (
          <OverlayAlertBox
            processingTimeline={processingTimeline}
            processingTimelineInfo={processingTimelineInfo}
          />
        ) : (
          ""
        )}
        {isMobile ? initialDialogMobile : initialDialogWeb}
        <Breadcrumbs aria-label="breadcrumb">
          <Link color="textSecondary" href={ROUTES.DASHBOARD}>
            Dashboard
          </Link>
          <Link color="textSecondary" href={ROUTES.MY_INVESTMENTS}>
            Funds
          </Link>
          <Link
            color="textSecondary"
            href={
              ROUTES.FUNDS + "/" + docId
              // this.props.match.params.fundid +
              // ""
            }
          // href={ROUTES.MY_INVESTMENTS}
          >
            {this.props.match.params.fundid}
          </Link>
          <Typography color="textPrimary" aria-current="page">
            Payment Details
          </Typography>
        </Breadcrumbs>

        <div className="body-content">
          {this.isUncertainRetry() && <p role="status">Retry the unchanged investment to confirm whether your previous submission was received. Your payment proof has been kept.</p>}
          {getVisibleEligibilityMessage(eligibilityMessage) && <p role={this.state.eligibilityError ? "alert" : "status"}>{eligibilityMessage}</p>}
          {this.state.eligibilityError && <Button color="primary" onClick={this.loadPaymentData}>Retry Fund Check</Button>}
          {this.state.fund?.fundType === "UITF" && this.props.fundEligibility?.data?.tier === 2 &&
            <Button color="primary" onClick={() => this.props.history.push(ROUTES.LONG_KYC_LAST)}>Get Fully Verified</Button>}
          <div className="payment-details">
            <Grid container spacing={1}>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <h1>Payment Details</h1>
                <Stepper
                  activeStep={investStep}
                  connector={<InvestmentConnector />}
                  alternativeLabel
                >
                  {this.getSteps().map((label, index) => (
                    <Step key={`step-${index}`}>
                      <StepLabel style={{ color: "#C8932A" }}>
                        {label}
                      </StepLabel>
                    </Step>
                  ))}
                </Stepper>
              </Grid>
            </Grid>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={12} md={12} lg={2} xl={2} />
              <Grid item xs={12} sm={12} md={12} lg={8} xl={8}>
                <Paper elevation={3} style={{ padding: "10px" }}>
                  <Grid container spacing={1}>
                    <Grid item xs={12} sm={12} md={12} lg={8} xl={8}>
                      <h3>Enter Amount to be Invested:</h3>
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      sm={12}
                      md={12}
                      lg={4}
                      xl={4}
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                        <CustomTextField
                          className="input-php"
                          variant="outlined"
                          label="Amount to be Invested"
                          value={amount}
                          onChange={this.handleChange}
                          name="amount"
                          InputProps={{
                            style: { textAlign: "right" },
                            inputComponent: this.NumberFormatCustom,
                          }}
                        />
                    </Grid>
                  </Grid>
                  {!isAmountBlocked && amount !== "" ? (
                    <div>
                      {amount < minAmount ||  amount > maxRemaining  ? (
                      // {amount < minAmount || (tier ===2 && amount > maxRemaining)  ? (
                        <Grid
                          item
                          xs={12}
                          sm={12}
                          md={12}
                          lg={12}
                          xl={12}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            flexWrap: "wrap",
                          }}
                        >
                          <WarningRoundedIcon
                            style={{ color: "#EA3636", marginRight: "5px" }}
                          />
                          <span
                            style={{ fontStyle: "italic", color: "#EA3636" }}
                          >
                            Your investment amount must be between {" "}
                            {/* Your investment amount must be {tier ===2?"between":"minimum of" } {" "} */}
                            <b>{formatter.format(minAmount)}</b> 
                            {" "}
                            and
                            {" "}
                            <b>{formatter.format(maxRemaining)}</b>
                           {/* {tier === 2 && <> and{" "}
                            <b>{formatter.format(maxRemaining)}</b></>} */}
                          </span>
                        </Grid>
                      ) : (
                        ""
                      )}
                    </div>
                  ) : (
                    ""
                  )}
                </Paper>
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={2} xl={2} />
            </Grid>
            {!eligibilityMessage && !isAmountBlocked && amount >= minAmount && amount <= maxRemaining &&
             noLimit}
            {/* {tier === 2 && amount >= minAmount && amount <= maxRemaining ? 
             noLimit
            :tier === 3 && amount >= minAmount && noLimit} */}
            {investStep > 0 ? (
              <div>
                {currentSelectedPayment === null ? (
                  ""
                ) : (
                  <Grid container spacing={1}>
                    <Grid item xs={12} sm={12} md={12} lg={2} xl={2} />
                    <Grid item xs={12} sm={12} md={12} lg={8} xl={8}>
                      <Paper elevation={3} style={{ padding: "10px" }}>
                        <h3>Submit Proof of Payment</h3>
                        <span style={{ fontStyle: "italic" }}>
                          *Maximum limit of 9.5 MB
                        </span>
                        <div style={{ fontSize: "small", marginTop: "4px" }}>
                          Supported files: PNG, JPG/JPEG, AVIF, HEIC/HEIF, and
                          PDF. HEIC/HEIF files will be converted for
                          compatibility.
                        </div>
                        <div className="upload">
                          <div className="upload-box">
                            <DropzoneAreaBase
                              classes={{
                                root: classes.dropzoneStyle,
                                icon: classes.dropzoneIcon,
                              }}
                              acceptedFiles={INVESTMENT_DROPZONE_ACCEPTED_TYPES}
                              maxFileSize={9500000}
                              filesLimit={1}
                              onDropRejected={() => {
                                this.setState({ errorModal: true });
                              }}
                              dropzoneText={
                                <p style={{ fontSize: "medium" }}>
                                  <b>
                                    Upload Payment Confirmation or Deposit Slip
                                    Here
                                  </b>
                                  <br />
                                  (Please ensure the confirmation number, total
                                  amount, and biller details are visible)
                                </p>
                              }
                              showPreviewsInDropzone={false}
                              showAlerts={false}
                              onAdd={(files) => this.handleDropzone(files)}
                              fileObjects={slip}
                            />
                          </div>
                          <br />
                          <Paper className="custom-list-upload" component="ul">
                            {picture !== null && (
                              <Chip
                                icon={<AttachFileOutlined />}
                                label={picture.name}
                                onDelete={() => this.deletePicture(false)}
                                className="custom-chip-upload"
                              />
                            )}
                          </Paper>
                          <FormControlLabel
                            value="end"
                            control={
                              <Checkbox
                                color="primary"
                                name="secondaryID"
                                checked={additionalUpload}
                                onClick={() => this.toggleSecondaryUpload()}
                              />
                            }
                            label="My payment confirmation details don't fit into a single screenshot"
                            labelPlacement="end"
                          />
                          {additionalUpload ? (
                            <>
                              <br />
                              <div className="upload-box">
                                <DropzoneAreaBase
                                  classes={{
                                    root: classes.dropzoneStyle,
                                    icon: classes.dropzoneIcon,
                                  }}
                                  acceptedFiles={INVESTMENT_DROPZONE_ACCEPTED_TYPES}
                                  maxFileSize={9500000}
                                  filesLimit={1}
                                  onDropRejected={() => {
                                    this.setState({ errorModal: true });
                                  }}
                                  dropzoneText={
                                    <p style={{ fontSize: "medium" }}>
                                      <b>Upload Secondary File Here</b>{" "}
                                    </p>
                                  }
                                  showPreviewsInDropzone={false}
                                  showAlerts={false}
                                  onAdd={(files) =>
                                    this.handleDropzoneSecondary(files)
                                  }
                                  fileObjects={this.state.slipSecondary}
                                />
                              </div>
                              <br />
                              <Paper
                                className="custom-list-upload"
                                component="ul"
                              >
                                {pictureSecondary !== null && (
                                  <Chip
                                    icon={<AttachFileOutlined />}
                                    label={pictureSecondary.name}
                                    onDelete={() => this.deletePicture(true)}
                                    className="custom-chip-upload"
                                  />
                                )}
                              </Paper>
                            </>
                          ) : (
                            ""
                          )}
                          <br />
                          <br />
                          <span className={classes.breakdownText}>
                            <b>Note:</b> If your payment doesn&apos;t match the
                            &quot;Total Amount to be Paid&quot;, we will process
                            the actual payment made to Rampver.
                          </span>
                          <br />
                          <br />
                        </div>
                      </Paper>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={2} xl={2} />
                  </Grid>
                )}

                <br />
                {loading || materializingPrimary || materializingSecondary ? (
                  <LinearProgress color="primary" />
                ) : (
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={12} md={12} lg={2} xl={2} />
                    <Grid item xs={12} sm={12} md={12} lg={6} xl={6} />
                    <Grid item xs={12} sm={12} md={12} lg={2} xl={2}>
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <Button
                          variant="contained"
                          className={classes.button}
                          disabled={investDisable}
                          onClick={(e) => this.submit(e)}
                          fullWidth={true}
                        >
                          Invest
                        </Button>
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={2} xl={2} />
                  </Grid>
                )}
              </div>
            ) : (
              ""
            )}
          </div>
        </div>
      </>
    );
  }
}

const condition = (authUser) => !!authUser;

const Payment = compose(
  withAuthorization(condition),
  withRouter,
  withFirebase,
  withCookies
)(PaymentBase);

export default PaymentPage;
